import api from "./index";

export const getNfseByContractService = async (contractNumber) =>
  await api.get(`/nfse/${encodeURIComponent(contractNumber)}`);

// Endpoint de simulacao: existe apenas em ambientes de validacao (DEV/STAGE/local) e e
// recusado com 404 em producao pelo proprio backend.
export const simulateNfseByContractService = async (contractNumber) =>
  await api.post(`/nfse/simulation/${encodeURIComponent(contractNumber)}`);
